import type { ComponentProps } from "react";
import Icon from "@/components/Icon";
import Stepper from "@/components/Stepper";
import type { StepType } from "@/components/Stepper/Stepper";
import SideSheetModal from "@/components/SideSheetModal";
import { useState } from "react";

interface MobileStepDisplayProps {
  steps: StepType[];
  currentStep: number;
  handleStepClick: (step: number) => void;
  variant?: ComponentProps<typeof Stepper>["variant"];
  title?: string;
}

export default function MobileStepDisplay({
  steps,
  currentStep,
  handleStepClick,
  variant = "status",
  title = "Steps"
}: MobileStepDisplayProps) {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  function handleStepClickWithClose(step: number) {
    handleStepClick(step);
    setSidebarOpen(false);
  }

  return (
    <div data-testid="mobile-step-display" className="py-4">
      <SideSheetModal isSidebarOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen} title={title}>
        <div className="pt-6">
          <Stepper
            variant={variant}
            stepsList={steps}
            activeIndex={currentStep}
            onStepClick={handleStepClickWithClose}
          />
        </div>
      </SideSheetModal>
      <div className="rounded-lg border border-sys-brand-outline-variant px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex flex-col">
          <span className="text-body-large-semibold">{steps[currentStep].headline}</span>
          <span className="text-body-medium text-sys-brand-on-surface-variant">
            {steps[currentStep].supportingText}
          </span>
        </div>
        <button
          onClick={() => setSidebarOpen(!isSidebarOpen)}
          data-testid="open-sidebar"
          className="p-0 m-0 flex items-center"
        >
          <Icon name="swap_vert" className="text-sys-brand-on-surface-variant" />
        </button>
      </div>
    </div>
  );
}
